import { DZentLogo, DZentLogoWhite } from '@/components/DZentLogo';

export default function LogoPreview() {
  return (
    <div className="min-h-screen pt-24" data-testid="logo-preview-page">
      {/* Light background variants */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-sm uppercase tracking-[0.2em] font-bold text-[#6366F1] mb-10">Logo Preview - Light Background</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Full logo */}
            <div className="space-y-4">
              <p className="text-xs text-gray-400 uppercase tracking-wider">Full Logo - Large</p>
              <div className="p-8 bg-[#f5f5f7] rounded-2xl flex items-center justify-center">
                <DZentLogo size={72} variant="full" />
              </div>
            </div>

            <div className="space-y-4">
              <p className="text-xs text-gray-400 uppercase tracking-wider">Full Logo - Medium</p>
              <div className="p-8 bg-[#f5f5f7] rounded-2xl flex items-center justify-center">
                <DZentLogo size={48} variant="full" />
              </div>
            </div>

            {/* Icon only */}
            <div className="space-y-4">
              <p className="text-xs text-gray-400 uppercase tracking-wider">Icon Only - Various Sizes</p>
              <div className="p-8 bg-[#f5f5f7] rounded-2xl flex items-center justify-center gap-6">
                <DZentLogo size={64} variant="icon" />
                <DZentLogo size={48} variant="icon" />
                <DZentLogo size={36} variant="icon" />
                <DZentLogo size={24} variant="icon" />
              </div>
            </div>

            {/* Nav size */}
            <div className="space-y-4">
              <p className="text-xs text-gray-400 uppercase tracking-wider">Navigation Size</p>
              <div className="p-8 bg-[#f5f5f7] rounded-2xl flex items-center justify-center">
                <DZentLogo size={40} variant="full" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Dark background variants */}
      <section className="py-16 bg-[#0A192F]">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-sm uppercase tracking-[0.2em] font-bold text-[#6366F1] mb-10">Logo Preview - Dark Background</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="space-y-4">
              <p className="text-xs text-white/40 uppercase tracking-wider">Full Logo - Large</p>
              <div className="p-8 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center">
                <DZentLogoWhite size={72} variant="full" />
              </div>
            </div>

            <div className="space-y-4">
              <p className="text-xs text-white/40 uppercase tracking-wider">Full Logo - Medium</p>
              <div className="p-8 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center">
                <DZentLogoWhite size={48} variant="full" />
              </div>
            </div>

            <div className="space-y-4">
              <p className="text-xs text-white/40 uppercase tracking-wider">Icon Only - Various Sizes</p>
              <div className="p-8 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center gap-6">
                <DZentLogoWhite size={64} variant="icon" />
                <DZentLogoWhite size={48} variant="icon" />
                <DZentLogoWhite size={36} variant="icon" />
                <DZentLogoWhite size={24} variant="icon" />
              </div>
            </div>

            <div className="space-y-4">
              <p className="text-xs text-white/40 uppercase tracking-wider">Navigation Size</p>
              <div className="p-8 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center">
                <DZentLogoWhite size={40} variant="full" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Black background (dark page) */}
      <section className="py-16 bg-[#0a0a0a]">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-sm uppercase tracking-[0.2em] font-bold text-[#ff0033] mb-10">Logo Preview - Dark Theme</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="space-y-4">
              <p className="text-xs text-white/40 uppercase tracking-wider">Full Logo on Black</p>
              <div className="p-8 bg-[#1a1a1a] border border-white/10 rounded-2xl flex items-center justify-center">
                <DZentLogoWhite size={64} variant="full" />
              </div>
            </div>

            <div className="space-y-4">
              <p className="text-xs text-white/40 uppercase tracking-wider">Icon on Black</p>
              <div className="p-8 bg-[#1a1a1a] border border-white/10 rounded-2xl flex items-center justify-center gap-6">
                <DZentLogoWhite size={64} variant="icon" />
                <DZentLogoWhite size={48} variant="icon" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
